import { InterviewQuestion } from 'src/DTO/Job.type';
import { useApi } from './useApi';
import { BaseHookRequest, BaseRequest } from './useApi.types';
import { GetInterviewHashResponse, GetInterviewQuestionsPayload } from './useInterview.types';

export const useGetInterviewHash: BaseHookRequest<GetInterviewHashResponse, null> = params => {
  const [{ getRequest }, state] = useApi<GetInterviewHashResponse>(params);
  const getInterviewHash: BaseRequest<null> = () =>
    getRequest<null>('/manager/application/hash/interview');
  return [getInterviewHash, state];
};

export const useGetInterviewQuestions: BaseHookRequest<
  InterviewQuestion[],
  GetInterviewQuestionsPayload
> = params => {
  const [{ getRequest }, state] = useApi<InterviewQuestion[]>(params);
  const getInterviewQuestions: BaseRequest<GetInterviewQuestionsPayload> = details => {
    const jobId = details?.variables.jobId;
    const path = jobId ? `/questions/${jobId}` : '/questions';

    getRequest<GetInterviewQuestionsPayload>(`public/interview${path}`);
  };
  return [getInterviewQuestions, state];
};
